import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PORTFOLIO_ADS } from "../data/mock";
import SocialEmbed from "./SocialEmbed";
import Reveal from "./Reveal";

const ErfolgeTeaser = () => {
  const highlights = PORTFOLIO_ADS.slice(0, 3);

  return (
    <section className="py-24 md:py-32 bg-neutral-50 relative overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-black/10 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-700">
                Highlight Cases
              </span>
              <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[1.02] mt-6 text-neutral-950">
                Echte Ergebnisse.{" "}
                <span className="bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 bg-clip-text text-transparent">
                  Echte Reichweite.
                </span>
              </h2>
            </div>
            <Link
              to="/erfolge"
              className="group inline-flex items-center gap-2 text-sm font-bold text-neutral-950 uppercase tracking-[0.12em] border-b-2 border-neutral-950 pb-1 hover:border-pink-500 hover:text-pink-500 transition-colors self-start md:self-end"
            >
              Alle Erfolge ansehen
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {highlights.map((ad, i) => (
            <Reveal key={ad.id} delay={i * 120}>
              <SocialEmbed
                url={ad.url}
                title={ad.title}
                subtitle={ad.platform}
                metric={ad.views ? `${ad.views} Views` : undefined}
                gradient={ad.gradient}
                brandLogo={ad.brandLogo}
                theme="light"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ErfolgeTeaser;
